import {
  BulkUploadApiStatusEnum,
  type MasterRateBulkUploadResponseInterface,
} from 'features/Enterprise/Payroll/types'

export enum StatusUploadEnum {
  IDLE = 'idle',
  ON_PROGRESS = 'uploadOnProgress',
  SUCCEEDED = 'uploadSucceded',
  FAILED = 'uploadFailed',
  PARTIAL_SUCCESS = 'partialSuccess',
}

export type ResultUploadType = Omit<MasterRateBulkUploadResponseInterface, 'status'>

export const STATUS_MAP: Record<BulkUploadApiStatusEnum, StatusUploadEnum> = {
  [BulkUploadApiStatusEnum.SUCCESS]: StatusUploadEnum.SUCCEEDED,
  [BulkUploadApiStatusEnum.FAILED]: StatusUploadEnum.FAILED,
  [BulkUploadApiStatusEnum.PARTIAL_SUCCESS]: StatusUploadEnum.PARTIAL_SUCCESS,
}
